// @ts-nocheck
import React from 'react';

import '@/style/components/MaterialProgressBar.scss';

export function MaterialProgressBar() {
  return (
    <div class="progress-container">
      <div class="progress-materializecss">
        <div class="indeterminate"></div>
      </div>
    </div>
  );
}
